import { render } from "./default.vue?vue&type=template&id=2c8d9ffc"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"

import "./default.vue?vue&type=style&index=0&id=2c8d9ffc&lang=scss"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__